import React from 'react';
import PerformanceChart from './PerformanceChart/PerformanceChart';
import BreakdownFiguresA from './BreakdownFigures/BreakdownFiguresA';
import FinancialBreakdown from './FinancialBreakdown/FinancialBreakdown';
import BreakdownFiguresB from './BreakdownFigures/BreakdownFiguresB';
import PerformanceByTimeBlock from './PerformanceByTimeBlock/PerformanceByTimeBlock';

// ASSP-7733 Add financialStats for FigureCards
//
const PerformanceBreakdown = ({
    campaign,
    performanceData,
    currentStation,
    dateRange,
    filters,
    financialStats,
    setFinancialStats,
    order = {},
    id = 'PerformanceBreakdown',
    performanceStats = [],
    dayPartTable = [],
    deliveryTable = []
}) => {
    return (
        <div
            id={id}
            style={{
                display: 'grid',
                // padding: '18px 0px 10px 0px',
                // height: 820,
                gap: 12,
                boxSizing: 'border-box',
                width: '100%',
                gridTemplateColumns: '13fr 5.4fr',
                gridColumn: '1 / -1'
            }}
        >
            <PerformanceChart
                campaign={campaign}
                performanceData={performanceData}
                currentStation={currentStation}
                dateRange={dateRange}
                // performanceStats={performanceStats}
            />
            {/* <PerformanceByAllStations /> */}
            <FinancialBreakdown
                order={order}
                campaign={campaign}
                showDetail={filters?.stationIds?.length}
                performanceStats={performanceStats} // not used
                dayPartTable={dayPartTable} // not used
                deliveryTable={deliveryTable ?? []} // ASSP-8141 null if no data in selected range
            />

            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                <BreakdownFiguresA
                    order={order}
                    performanceStats={performanceData}
                    deliveryStats={deliveryTable}
                />
                <BreakdownFiguresB
                    order={order}
                    performanceStats={performanceData}
                    deliveryStats={deliveryTable}
                    financialStats={financialStats}
                    setFinancialStats={setFinancialStats}
                />
            </div>

            {/* <FinancialBreakdown order={order} performanceStats={performanceStats} /> */}
            <PerformanceByTimeBlock
                data={dayPartTable ?? []} // ASSP-8141 null if no data in selected range
                showDetail={filters?.dayPartIds?.length > 0}
                deliveryTable={deliveryTable ?? []} // ASSP-8141 null if no data in selected range
            />
        </div>
    );
};
export default PerformanceBreakdown;
